import React from 'react';
import ReportFrame from '../ReportFrame';

export default class ProjectAssignmentRevenueExpenses extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Project Assignment Revenue and Expenses Summary'
          reportParams={reportParams}
          id='projectassignmentrevenueandexpensessummary'
          name='projectassignmentrevenueandexpensessummary'
          title='Project Assignment Revenue & Expenses Summary'
        />
      </div>
    );
  }
}
